import DashboardLayout from "components/layouts/dashboard-layout";
import PageLinks from "components/page-links";
import React from "react";
import PageHeader from "./components/header";
import WhatsInside from "./components/whatsInside";
import GetStarted from "./components/get-started";

const PitchEasy = () => {
  return (
    <DashboardLayout>
      <>
        <PageLinks
          from={{ name: "Overview", link: "/overview" }}
          current="Promo Cards"
        />
        <PageHeader />
        <WhatsInside />
        <GetStarted />
      </>
    </DashboardLayout>
  );
};

export default PitchEasy;
